import React, { FC } from "react";
import FullScreenView from "../fullscreen-view";
import classnames from "classnames";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";
import DeliveryFullscreen from "./delivery-fullscreen";

const LogisticsView: FC = () => {
  const { t } = useTranslation();
  const history = useHistory();

  return (
    <FullScreenView>
      <div className="fcv-container">
        <DeliveryFullscreen />
      </div>
    </FullScreenView>
  );
};

export default LogisticsView;
